import {Modal} from "@mui/material";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {ReactComponent as IconInfo} from "assets/img/icon/icon-info-gold.svg";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import {useViewController} from "data/services/locator";
import {isEqual} from "lodash";
import {observer} from "mobx-react";
import React from "react";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {PrimaryButton, SecondaryButton} from "views/components/style";
import {IModalsController} from "views/controllers/modals/modals.controller";

export const NewPickModal: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close} = controller;
	const isVisible = isEqual(visibleModal, ModalType.NEW_PICK);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("modal.new_pick.title", "New Pick Title");
	const message = i18n.t("modal.new_pick.description", "New Pick Description");

	const onReload = () => {
		window.location.reload();
	};

	return (
		<Modal open={isVisible} onClose={close}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconInfo />
					</ModalHeader>
					<ModalBody>
						<ModalTitle>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<SecondaryButton onClick={close} fullWidth variant="contained" size="large">
							{i18n.t("modal.new_pick.stay", "Stay")}
						</SecondaryButton>
						<PrimaryButton
							fullWidth
							onClick={onReload}
							variant="contained"
							size="large">
							{i18n.t("modal.new_pick.continue", "Continue")}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
